import { render, staticRenderFns } from "./SensorDetails.vue?vue&type=template&id=041f122f&"
import script from "./SensorDetails.vue?vue&type=script&lang=js&"
export * from "./SensorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports